import ReactPlayer from 'react-player';
import styles from './CommercialReel.module.css';

const CommercialReel = () => {
  return (
    <section className={styles.section}>
      <h1 className={styles.heading}>
        Commercial Reel
      </h1>
      <p className={styles.description}>
        A glimpse into my work in front of the camera — featuring notable commercial projects that highlight performance, energy, and presence.
      </p>
      <div className={styles.videoWrapper}>
        <ReactPlayer
          url="https://www.youtube.com/watch?v=I0eM2q1U4QM"
          controls={true}
          width="100%"
          height="100%"
        />
      </div>
    </section>
  );
};

export default CommercialReel;
